import React from 'react'

export default function Footer() {
    return (
        <div className="copy-otr">
            <div className="container-fluid">
                <div className="copy-inr" style={{ display: 'flex', justifyContent: 'space-between'}}>
                    <div className="copy-name body-s" >
                        Copyright © 2021 by Certify Labs. All rights reserved.
                    </div>
                    <div className="privacy-link" style={{ justifyContent: 'end' }}>
                        <a
                            href="pages/Privacy-Policy.html"
                            className="link body-sb"
                        >
                            Privacy Policy
                        </a>
                        <span className="dot">•</span>
                        <a
                            href="pages/Terms-of-Services.html"
                            className="link body-sb"
                        >
                            Terms of Service
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
